import React from "react";
import Dropdown from "components/dropdown";
import { AiTwotoneEdit } from "react-icons/ai";
import { BsThreeDots } from "react-icons/bs";
import { AiOutlineShop } from "react-icons/ai";
// import { FiSettings } from "react-icons/fi";
// import { TiLightbulb } from "react-icons/ti";

function CardMenu(props: {
  transparent?: boolean,
  onButtonClick?: () => void,
  setOpenDialog?: React.Dispatch<React.SetStateAction<boolean>>
  onDeleteClick?: () => void,
}) {
  const { transparent, onButtonClick, setOpenDialog,onDeleteClick  } = props;
  const [open, setOpen] = React.useState(false);
  return (
    <Dropdown
      button={
        <button
        style={{ padding: "18px 9px"}}
          onClick={() => setOpen(!open)}
          className={`flex items-center text-xl hover:cursor-pointer ${transparent
            ? "bg-none text-white hover:bg-none active:bg-none"
            : "bg-surfaceSecondary px-2 py-1 text-brand-500 hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70"
            } linear justify-center rounded-lg font-bold transition duration-200 p-10`}
        >
          <BsThreeDots className="h-6 w-6" />
        </button>
      }
      animation={"origin-top-right transition-all duration-300 ease-in-out"}
      classNames={`${transparent ? "top-8" : "top-11"} right-0 w-max`}
      children={
        <div className="z-50 w-max rounded-xl bg-surfacePrimary border border-borderPrimary py-3 px-4 text-sm shadow-xl shadow-shadowPrimary">
          <p className="hover:text-textPrimary flex cursor-pointer items-center gap-2 text-textSecondary hover:font-medium" onClick={() => {
             if (setOpenDialog) {
               setOpenDialog(true);
               onButtonClick();
             }
          }}>
            <span>
              <AiTwotoneEdit />
            </span>
            Edit
          </p>
          <p onClick={() => {
             if (setOpenDialog) {
              onDeleteClick()
             }
          }} className="hover:text-textPrimary mt-2 flex cursor-pointer items-center gap-2 pt-1 text-textSecondary hover:font-medium">
            <span>
              <AiOutlineShop />
            </span>
            Delete
          </p>
        </div>
      }
    />
  );
}

export default CardMenu;
